// investment info for all companies, etc
import Promise from 'bluebird'
import _ from 'lodash'
import api from '../../axios_api'
import router from '../../main'

const state = {
  investment: [],
  proRata: {}
}
const getters = {
  investmentsByPortfolioId: (state) => (id, workspace) => {
    return _.filter(state.investment, function (o) { return (o.portfolio_item === id && o.workspace === workspace) }) || []
  },
  investments: (state) => {
    return state.investment
  },
  proRataChartData: (state) => { return state.proRata },
  showProRataChart: (state) => {
    if ((state.proRata.prorata && state.proRata.prorata.length > 0) || (state.proRata.leadInvestor && state.proRata.leadInvestor.length > 0) || (state.proRata.boardSeat && state.proRata.boardSeat.length > 0)) {
      return true;
    }
    else {
      return false;
    }
  }
}

const buildFormData = function (payload) {
  let formData = new FormData();

  /*
      Add the form data we need to submit
  */
  for (var i = 0; i < payload.files.length; i++) {
    let file = payload.files[i];

    formData.append('files[' + i + ']', file, file.name);
  }
  formData.append('encrypt', JSON.stringify({ encrypt: { data: payload.data } }));

  return formData;
}

const mutations = {
  initialize(state) {
    state.investment = [];
    state.proRata = {};
  },
  merge(state, payload) {
    // merge our local with what has returned
    if (_.isNil(payload) || _.isEmpty(payload)) return
    if (!_.isArray(payload)) payload = [payload]
    state.investment = _.map(state.investment, addr => {
      let index = _.findIndex(payload, function (a) { return a._id === addr._id })
      if (index >= 0) {
        return _.first(_.pullAt(payload, index))
      }
      return addr
    })
    if (!_.isEmpty(payload)) state.investment = _.concat(state.investment, payload)
    state.investment = _.without(state.investment, null, undefined)
  },
  mergeProRata(state, payload) {
    if (_.isNil(payload) || _.isEmpty(payload)) return
    state.proRata = payload;
  },
  remove(state, payload) {
    if (_.isNil(payload) || _.isEmpty(payload)) return
    // remove the item by the id (either _id or uaid)
    state.investment = _.filter(state.investment, function (a) { return a._id !== payload && a.uaid !== payload })
  }
}

const actions = {
  start({ state, dispatch, commit }) {
    commit('initialize')
    dispatch('getInvestment');
    dispatch('getProRataData');
  },
  stop({ commit }) {
    // clean up
    commit('initialize')
  },
  cycle({ }) { },
  createInvestment({ commit, dispatch }, payload) {
    // create a new investment(es), add it to our current list
    let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/new/investment`;
    if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'no arguments' })
    return api.post(url, { encrypt: { data: payload } })
      .then(res => {
        let investment = res.data.encrypt.success;
        if (!_.isNil(investment) && !_.isEmpty(investment)) commit('merge', investment)
        dispatch('getInvestment')
          .then(() => {
          })
          .catch(() => { })
        return Promise.resolve(investment)
      })
      .catch(err => {
        console.error(`Error during investment post: ${err}`)
        return Promise.reject(err)
      })
  },
  deleteInvestment({ commit }, payload) {
    // delete investment
    if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'no arguments' })
    // delete the investment with the given id
    return api.delete(`/investment/${payload._id}`)
      .then(res => {
        // remove the id from our local investment list
        commit('remove', payload._id)
        // should be 204
        return Promise.resolve()
      })
      .catch(err => {
        console.error(`Error during investment delete: ${err}`)
        return Promise.reject(err)
      })
  },
  getInvestment({ commit }) {
    if (localStorage.fiifi) {
      let fiifi = JSON.parse(localStorage.fiifi).user
      if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
        let url = `${fiifi.id}/${fiifi.workspace_id}/investment`;
        return api.get(url, {})
          .then(res => {
            commit('merge', res.data.encrypt.success)
            return Promise.resolve(res.data.encrypt.success)
          })
          .catch(err => {
            console.error(`Error during investment fetch: ${err}`)
            return Promise.reject(err)
          })
      }
    }
  },
  updateInvestment({ commit, dispatch }, payload) {
    let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/new/investment`;
    if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'No arguments provided' })
    return api.patch(url, { encrypt: { data: payload } })
      .then(async res => {
        await dispatch('getInvestment')
          .then((data) => {
            return Promise.resolve(data)
          })
          .catch(() => { })
        commit('merge', res.data.encrypt.data)
      })
      .catch(err => {
        console.error(`Error during investment patch: ${err}`)
        return Promise.reject(err)
      })
  },
  removeCompany({ dispatch }, payload) {
    // delete all attachments related to a company
    return dispatch('apiDeleteInvestmentsForCompany', payload)
  },
  apiDeleteInvestmentsForCompany({ state, dispatch, rootGetters }, payload) {
    // delete all attachments for company, then do a hard fetch
    if (_.isNil(payload) || _.isEmpty(payload) || !payload.ucid) return Promise.reject({ error: 'Missing requried paraeters.' })
    let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/company/investment/${payload.ucid}`;
    // if (currentRole && currentRole._id) {
    //   url = `/attachment/company/${payload.ucid}?account=${currentRole.account}`;
    // } else url = `/attachment/company/${payload.ucid}`
    return api.delete(url)
      .then(res => {
        // clean, hard fetch
        return dispatch('apiCleanFetchInestments')
      })
      .catch(err => {
        console.error(`Error deleting attachments: ${err}`)
        return Promise.reject({ error: err })
      })
  },
  apiCleanFetchInestments({ state, commit }) {
    // full fetch from the server, overwriting local infos
    return new Promise((resolve, reject) => {
      let params = {}
      params.force = true
      let url = `/${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/investment`;

      return api.get(url, { params })
        .then(res => {
          // merge the data with our local info
          state.investment = res.data.encrypt.success;
          return resolve(res.data.encrypt.success)
        })
        .catch(err => {
          return reject(err)
        })
    })
  },
  apiRegistrarSave({ dispatch, commit }, payload) {
    if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'no arguments' })
    // delete the investment with the given id
    return api.post(`/${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/registrar_item`, { encrypt: { data: payload } })
      .then(res => {
        let investment = res.data.encrypt.success;
        if (!_.isNil(investment) && !_.isEmpty(investment)) commit('merge', investment)
        dispatch('getInvestment')
          .then(() => {
          })
          .catch(() => { })
        return Promise.resolve(res)

      })
      .catch(err => {
        console.error(`Error during investment delete: ${err}`)
        return Promise.reject(err)
      })
  },
  apiRegistrarUpdate({ dispatch, commit }, payload) {
    if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'no arguments' })
    // delete the investment with the given id
    return api.patch(`/${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/registrar_item`, { encrypt: { data: payload } })
      .then(res => {
        let investment = res.data.encrypt.success;
        if (!_.isNil(investment) && !_.isEmpty(investment)) commit('merge', investment)
        dispatch('getInvestment')
          .then(() => {
          })
          .catch(() => { })
        return Promise.resolve(res)

      })
      .catch(err => {
        console.error(`Error during investment delete: ${err}`)
        return Promise.reject(err)
      })
  },
  apiRegistrarDelete({ commit }, payload) {
    if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'no arguments' })
    // delete the investment with the given id
    return api.delete(`/${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/registrar_item/${payload}`)
      .then(res => {
        commit('remove', payload)

        return Promise.resolve(res)

      })
      .catch(err => {
        console.error(`Error during investment delete: ${err}`)
        return Promise.reject(err)
      })
  },
  getProRataData({ commit }) {
    if (localStorage.fiifi) {
      let fiifi = JSON.parse(localStorage.fiifi).user
      if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
        let url = `proRataGraphs/${fiifi.workspace_id}`;
        return api.get(url, {})
          .then(res => {
            commit('mergeProRata', res.data.encrypt.success)
            return Promise.resolve(res.data.encrypt.success)
          })
          .catch(err => {
            console.error(`Error during investment fetch: ${err}`)
            return Promise.reject(err)
          })
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}